<div class="headerMargin">
    <prism-header [userName]="userName" [menu]="menuItems" menuTone="neutral" enable-authentication appTitle=" "
            useCustomRouting="true" (prismClick)="setActiveMenu($event.detail.data)" logoutText="Sign Out"
            [logoutUrl]="logOutUrl">
            <img slot="logo" src="../../../assets/images/sky.png" alt="sky Logo" style="height: 4rem; width: auto;" />
    </prism-header>
    
</div>
<hr style="border: none; border-bottom: 1px solid #ccc; margin: 24px 0;">